import {Component, OnInit} from '@angular/core';
import {InformationsService} from '../../services/informations.service';
import {Information} from '../../model/information';
import {Label} from '../../model/Label';
import {InformationType} from '../../model/InformationType';
import {FaqCategory} from '../../model/FaqCategory';
import {Observable} from 'rxjs';
import {AdminPageModelComponent} from "../../components/admin/admin-page-model/admin-page-model.component";

import {CreateInformationActionComponent} from "./create-information-action/create-information-action.component";
import {ListInformationsComponent} from "./list-informations/list-informations.component";
import {DynamicModalFormComponent} from "../../components/common/dynamic-modal-form/dynamic-modal-form.component";

@Component({
    selector: 'app-infos',
    templateUrl: './infos.component.html',
    imports: [
    AdminPageModelComponent,
    CreateInformationActionComponent,
    ListInformationsComponent,
    DynamicModalFormComponent
],
    styleUrls: ['./infos.component.css']
})
export class InfosComponent implements OnInit {
  $infos: Observable<Information[]>;

  search = '';

  toCreate: Information;
  toPublish: Information;
  toMove: Information;
  toMoveDestivation: InformationType;

  constructor(private infosService: InformationsService) {
  }

  ngOnInit(): void {
    this.$infos = this.infosService.getObjects();
  }

  createInfo(info: Information): void {
    this.infosService.createObject(info);
  }

  edit(info: Information): void {
    this.toCreate = Object.assign({}, info);
  }

  moveToDestination(): void {
    this.toMove.type = this.toMoveDestivation;
    this.infosService.createObject(this.toMove);
  }

  setToHistory(info: Information): void {
    this.toMove = Object.assign({}, info);
    this.toMoveDestivation = InformationType.HISTORY;
  }

  setToArchive(info: Information): void {
    this.toMove = Object.assign({}, info);
    this.toMoveDestivation = InformationType.ARCHIVED;
  }

  publishInfo(): void {
    this.toPublish.publication = new Date();
    this.toPublish.draft = false;
    this.infosService.createObject(this.toPublish);
  }
}
